import { InputNumber, Tooltip } from 'antd'
import classNames from 'classnames'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import { cfgAtom } from './atom'
import { useAtom } from 'jotai'
import { MySlider } from '~/components/ui/MySlider'

export const CfgComp: React.FC<{
  disabled: boolean
}> = ({ disabled }) => {
  const [cfg, setCfg] = useAtom(cfgAtom)

  return (
    <div className="flex items-center mb-3">
      <span className={classNames('text-neutral-500 w-[120px]')}>
        提示词相关性{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title="提示词相关性（CFG scale）表示AI对描述参数的倾向程度"
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <MySlider
        className="flex-1"
        step={0.5}
        min={1}
        max={30}
        value={cfg}
        onChange={val => {
          setCfg(val)
        }}
        tooltip={{ formatter: null }}
        disabled={disabled}
      />
      <InputNumber
        min={1}
        max={30}
        className={styles.inputNumber}
        value={cfg}
        onChange={val => {
          setCfg(Number(val?.toFixed(2)))
        }}
        disabled={disabled}
      />
    </div>
  )
}
